import { Component, Input, OnInit } from '@angular/core';
import { DeliveryForDate } from 'src/app/api/contracts/order';
import { DeliveryForDateStatus } from 'src/app/types/delivery-for-date';

@Component({
  selector: 'app-delivery-for-date-status',
  templateUrl: './delivery-for-date-status.component.html',
  styleUrls: ['./delivery-for-date-status.component.scss'],
})
export class DeliveryForDateStatusComponent  implements OnInit {
  public readonly deliveryStatuses = DeliveryForDateStatus;

  @Input() deliveryItem!: DeliveryForDate;

  constructor() { }

  ngOnInit() {
    return;
  }

}
